import type { FC, ReactNode } from 'react';
import styles from './ReferencesList.module.scss';
import { TitleRow } from 'components/TitleRow';
import { ReferencesItem } from 'components/ReferencesItem';
import { WorkerReference } from 'redux/Api/referencesApi/type';

interface ReferencesListTypes {
  data: WorkerReference[];
  intersectionComponent: ReactNode;
  hidePerformer?: boolean;
  workerId?: string;
}
export const ReferencesList: FC<ReferencesListTypes> = ({
  data,
  intersectionComponent,
  hidePerformer = false,
  workerId,
}) => {
  const dataTitle = ['Название', 'Дата создания', 'Кто создал', ''];

  return (
    <div className={styles.root}>
      <TitleRow data={dataTitle} title={'references'} hidePerformer={hidePerformer} />
      {data?.length ? (
        <div className={styles.window}>
          {data.map((reference, index) => (
            <ReferencesItem
              key={index}
              reference={reference}
              hidePerformer={hidePerformer}
              workerId={workerId}
            />
          ))}
          {intersectionComponent}
        </div>
      ) : (
        <div className={styles.noting}>Нет справок</div>
      )}
    </div>
  );
};
